import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-sources-nav",
  "use": "tamr-icon-sources-nav-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-sources-nav\"><path d=\"M29.3,8.5l-9-8A2,2,0,0,0,19,0H4A2,2,0,0,0,2,2V30a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,29.3,8.5ZM18.2,4L26,10.9V20H6V4H18.2ZM6,28V24H26v4H6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol